import React from 'react';
export var EditProfile = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: color },
        React.createElement("g", { stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("path", { d: "m8.795 20.25.75-4.5M6.545 20.25h3M1.295 11.75h13.71M11.795 15.75h-7.5a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h16.5a3 3 0 0 1 3 3V9M23.175 14.87l-7.63 7.63-3.75.75.75-3.75 7.63-7.63a2.11 2.11 0 0 1 3 0v0a2.11 2.11 0 0 1 0 3v0Z" }))));
};
